import { useMemo } from "react";

import {
    useLoanInfos,
    AbfOrderFundingType,
    useLoopscaleWalletContext,
    LoanInfoSorting,
    AbfLoanExpanded
} from "@bridgesplit/abf-react";
import { useLoansPagination } from "app/api";
import { SortDirection } from "@bridgesplit/utils";
import { useAppDialog } from "app/utils";
import { getLoanDetailColumnDefs } from "app/components/portfolio/LoansSection";
import { PositionsTable } from "app/components/common";

import { useMarketContext } from "../common";

export default function UserBorrowPositions() {
    const {
        data: { userWalletAddress: activeWallet }
    } = useLoopscaleWalletContext();

    const { principalMint } = useMarketContext();

    const pagination = useLoansPagination({
        initialPageSize: 5,
        initialState: { principalMint }
    });

    const {
        data: loans,
        totalLoans,
        isLoading,
        isFetching
    } = useLoanInfos({
        loanFilter: {
            orderFundingTypes: AbfOrderFundingType.Standard,
            principalMints: principalMint ? [principalMint] : [],
            lenders: [],
            borrowers: activeWallet ? [activeWallet] : [],
            sortSide: SortDirection.Asc,
            collateralMints: [],
            sortType: LoanInfoSorting.StartTime,
            loanAddresses: [],
            collateralIdentifiers: []
        },
        pagination: pagination.backendPagination,
        skip: !activeWallet
    });

    const { open } = useAppDialog();
    const items = useMemo(() => pagination.visibleData(loans), [pagination, loans]);
    const columns = useMemo(() => getLoanDetailColumnDefs(open), [open]);

    return (
        <PositionsTable<AbfLoanExpanded>
            items={items}
            columns={columns}
            getRowKey={(loan) => loan.loan.address}
            page={pagination.params.page}
            setPage={pagination.setPage}
            pageSize={pagination.params.pageSize}
            totalCount={totalLoans}
            loading={isLoading || isFetching}
            emptyPlaceholder="No ongoing loans"
        />
    );
}
